import React, { useState } from "react";
import "./AboutFAQs.css";

const faqData = [
  {
    question: "Can clients outside Nigeria apply for loans?",
    answer:
      "Yes. Customers abroad can also access our services by leveraging assets like diamonds, gold, fine jewelry, and luxury wristwatches. We provide guidance on international shipping and secure logistics to ensure your valuables reach us safely.",
  },
  {
    question: "How is the value of my asset determined?",
    answer:
      "Our experts assess each asset based on current market demand, brand reputation, condition, and supporting documentation. This evaluation helps us decide the loan amount you can receive.",
  },
  {
    question: "Do you only offer loans?",
    answer:
      "No. We also buy and sell high-value items such as jewelry, luxury watches, and other assets through our platform.",
  },
  {
    question: "How do I know the items you sell are genuine?",
    answer:
      "Every item is authenticated by experts before being listed, ensuring customers only purchase verified, high-quality assets.",
  },
  {
    question: "How is a line of credit different from a standard loan?",
    answer:
      "Instead of one lump sum, a line of credit allows you to borrow, repay, and borrow again up to your approved limit, giving you flexibility.",
  },
  {
    question: "Can I use multiple assets to increase my credit line?",
    answer:
      "Yes. Combining assets such as cars, jewelry, or watches can increase your borrowing power.",
  },
  {
    question:
      "Will I still have access to my parked asset during the loan term?",
    answer:
      "No. The asset remains in our secure facility throughout the loan duration and is not available for personal use until repayment is completed.",
  },
  {
    question:
      "Can I keep my item with you for a while, even after repaying the loans?",
    answer:
      "Absolutely, and it's for free. Just ensure that your repayment has been completed. Terms and Conditions applies",
  },
  {
    question: "How do international customers ship their items?",
    answer:
      "We provide guidance and partnerships with trusted logistics companies for insured shipping of valuables from abroad.",
  },
  {
    question: "What happens if I cannot repay my loan?",
    answer:
      "If repayment is not made within the agreed term, ownership of the pledged asset may transfer to Respected Solutions in line with our loan agreement. We encourage communication before maturity to explore extension or restructuring options.",
  },
  {
    question: "Do I need payslips, a guarantor, or a credit score to qualify?",
    answer:
      "No. Our loans are based on the strength of your collateral, not your personal income records or credit history.",
  },
  {
    question: "Can I extend or renew my loan term?",
    answer:
      "Yes. Customers may apply for extensions or rollovers before the maturity date, though terms and conditions apply.",
  },
  {
    question: "Can I bring in my watch for repair or servicing?",
    answer: "Yes. We provide professional servicing for luxury watches.",
  },
  {
    question: "Do you offer jewelry cleaning?",
    answer:
      "Yes. Jewelry items can be cleaned and restored to maintain shine and value.",
  },
  {
    question: "What investment opportunities do you provide?",
    answer:
      "We offer structured plans that pay you a fixed monthly return: 3% per month for 5 years, 2.9% per month for 1 year, and 2.1% per month for 6 months.",
  },
  {
    question: "How much money can I access from my asset?",
    answer:
      "The loan amount depends on the current market value of your item. In most cases, clients receive a significant portion of that value, while still retaining full ownership of their asset.",
  },
  {
    question: "What is the least I can invest?",
    answer: "You can begin investing with as low as ₦1 million.",
  },
  {
    question: "How will I receive my returns?",
    answer:
      "Returns are paid directly to your bank account at the end of your plan. You can either withdraw your capital or roll it over into a new plan.",
  },
  {
    question: "Who do I contact if I need help?",
    answer:
      "Our customer support team is available to assist you with questions about loans, investments, shipping, or asset storage.",
  },
  {
    question: "Why should I choose Respected Solutions?",
    answer:
      "Because we combine speed, safety, and transparency. With us, you get quick access to funds, clear investment terms, and peace of mind knowing your valuables are always protected.",
  },
  {
    question: "Do you work with other businesses?",
    answer:
      "Yes. We partner with logistics companies for international shipping, jewelers for asset verification, and insurers to guarantee asset safety.",
  },
  {
    question: "Can I collaborate with Respected Solutions as a partner?",
    answer:
      "Yes. We welcome partnership inquiries from businesses in finance, logistics, insurance, and luxury goods.",
  },
  {
    question: "Can I list my own items for sale?",
    answer:
      "Yes. Clients can sell directly through the marketplace. Each item is inspected and authenticated before being approved for listing.",
  },
  {
    question: "How do I know the items on Awoof Marketplace are genuine?",
    answer:
      "Every product goes through expert evaluation and authentication. Only certified and verified items are made available for sale.",
  },
  {
    question: "What type of items are usually sold?",
    answer:
      "You can find a range of products including gold, diamonds, fine jewelry, luxury watches, cars, and high-end gadgets.",
  },
  {
    question: "Are prices negotiable?",
    answer:
      "Yes, in most cases. Buyers and sellers can agree on a fair price, with Respected Solutions providing valuation support where needed.",
  },
  {
    question: "How does delivery work?",
    answer:
      "Items purchased can be collected in person or shipped through our trusted logistics partners. For international buyers, secure and insured shipping is arranged.",
  },
  {
    question: "Is there buyer protection?",
    answer:
      "Yes. We act as a trusted intermediary to ensure that transactions are fair and both buyers and sellers are protected.",
  },
  {
    question: "Can I trade in my item instead of selling outright?",
    answer:
      "Yes. Customers can either sell directly, or use the item as collateral for a loan.",
  },
  {
    question: "Do you charge fees for selling on the marketplace?",
    answer:
      "A small service or commission fee may apply on completed sales. Fees are always communicated upfront before listing.",
  },
  {
    question: "How does the referral/commission system work?",
    answer:
      "You earn a commission whenever you successfully bring in a client who uses any of our services; this includes purchases on Awoof Marketplace, investments, and loans.",
  },
  {
    question: "Do I need to invest or borrow myself before I can refer?",
    answer:
      "No. You don’t need to take a loan or make an investment yourself. The referral program is free and open to everyone.",
  },
  {
    question: "Is there a limit to how many people I can refer?",
    answer:
      "No. There’s no cap on referrals. The more clients you bring in, the more commission you earn.",
  },
  {
    question: "How do I qualify for a commission?",
    answer:
      "Refer a client and contact us with proof of referral. You get a commission after a successful transaction between the client and the company.",
  },
];

const AboutFAQs = () => {
  const [openIndexes, setOpenIndexes] = useState([]);
  const [showAll, setShowAll] = useState(false);

  const toggleFAQ = (index) => {
    if (openIndexes.includes(index)) {
      setOpenIndexes(openIndexes.filter((i) => i !== index));
    } else {
      setOpenIndexes([...openIndexes, index]);
    }
  };

  // Show only first 8 unless "showAll" is true
  const visibleFAQs = showAll ? faqData : faqData.slice(0, 8);

  return (
    <section className="about-faqs" id="about">
      <div className="about-us">
        <section className="about-us-section">
          <h2 className="about-us-title">Who we are?</h2>
          <p className="about-us-text">
            Respected Solutions and Investment Limited is a government approved
            short term loan and pawn shop in Lagos that is committed to giving
            fast, safe, and convenient loans against luxury items. We have years
            of experience and a reputation for transparency, dependability, and
            professionalism. We give fair market values and flexible repayment
            terms for an instant cash loan or a gold loan, watch loan, or
            jewelry loan. Our professional team guarantees that your property is
            treated with care and safely stored until you repay your loan in
            full. If you're looking for pawn shops close to you, we are your
            trusted partner, dedicated to helping you realize the cash value of
            your property without selling it.
          </p>
        </section>

        <section className="about-us-section">
          <h2 className="about-us-title">Our mission</h2>
          <p className="about-us-text">
            Our Mission is to make available quick and secure financial services
            in the form of secured pawn loans with the highest integrity and
            professionalism. We want to provide fair loan terms, clear
            processes, and competitive estimates to enable businesses and
            individuals to avail instant money without financial hardships. Our
            mission is to provide a secure financial service in which our
            customers can confidently borrow against their precious belongings
            knowing their goods are well taken care of. With our secure storage,
            convenient repayments, and unparalleled customer experience, we
            desire to be your most reliable pawn shop in proximity, catering to
            the good people of Lagos efficiently and reliably.
          </p>
        </section>
      </div>

      <div className="faq-container">
        <p className="faq-updates">LATEST UPDATES</p>
        <h2 className="faq-title">Frequently Asked Questions (FAQs)</h2>

        {visibleFAQs.map((item, index) => (
          <div
            key={index}
            className={`faq-item ${
              openIndexes.includes(index) ? "active" : ""
            }`}
          >
            <div className="faq-question" onClick={() => toggleFAQ(index)}>
              <h3>{item.question}</h3>
              <span className="faq-icon">
                {openIndexes.includes(index) ? "-" : "+"}
              </span>
            </div>
            {openIndexes.includes(index) && <p>{item.answer}</p>}
          </div>
        ))}

        {/* View More / Less button */}
        <div className="faq-toggle">
          <button onClick={() => setShowAll(!showAll)}>
            {showAll ? "View Less" : "View More"}
          </button>
        </div>
      </div>
    </section>
  );
};

export default AboutFAQs;
